export const OUTLET_ALLOWED_MODULES = [
  "orders",
  "staffs",
  // "promo",
  // "rtf",
  "return_to_shipper",
  "shelves",
  "product_inventory",
  "shipment_inventory",
  "product_fetch",
  // "line_haul",
  // "line_haul_request",
  "pickup_locations",
  "pickup_manifests",
  // "linehaul_manifests",
  // "3pl_manifest",
  // "product_manifest",
] as const;